// TODO
<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Overtime Payment Calculation</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row">
      <div class="col-md-2 fit-content">
        <h4 class="mt-2">Company</h4>
      </div>
      <div class="col-md-5 fit-content">
        <select class="form-control" v-model="company" @change="changeCompany">
          <option v-for="company in companies" :key="company.CompanyName" :value="company.CompanyName">
            {{ company.CompanyName }}
          </option>
        </select>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Job Grade Setting -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <table style="width: auto !important" class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 100px">Job Grade</th>
                <th class="text-center" style="width: 200px">StandBy 12-Hours</th>
                <th class="text-center" style="width: 200px">StandBy 24-Hours</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(jg, i) in jobGrade" :key="jg.grade">
                <td class="text-center">{{ jg.JobGrade }}</td>

                <td v-if="mode == 'view'" class="text-center">{{ jg.StandBy12HourRate }}</td>
                <td v-if="mode == 'edit'" class="text-center">
                  <input type="text" v-model="jg.StandBy12HourRate" class="form-control height26 text-center" />
                </td>

                <td v-if="mode == 'view'" class="text-center">{{ jg.StandBy24HourRate }}</td>
                <td v-if="mode == 'edit'" class="text-center" style="position: relative">
                  <input type="text" v-model="jg.StandBy24HourRate" class="form-control height26 text-center" />

                  <span v-if="jg.IsManual" @click="removeJobGrade(i)"
                    style="position: absolute; right: -8px; top: 6px; color: #FF0000; cursor: pointer;"><i
                      class="fa fa-minus-circle"></i></span>
                </td>
              </tr>

              <tr v-for="(njg, i) in newJobGrade" :key="njg.grade">
                <td class="text-center">
                  <input type="text" v-model="njg.JobGrade" class="form-control height26 text-center" />
                </td>

                <td class="text-center">
                  <input type="text" v-model="njg.StandBy12HourRate" class="form-control height26 text-center" />
                </td>

                <td class="text-center" style="position: relative">
                  <input type="text" v-model="njg.StandBy24HourRate" class="form-control height26 text-center" />

                  <span @click="removeNewJobGrade(i)"
                    style="position: absolute; right: -8px; top: 6px; color: #FF0000; cursor: pointer;"><i
                      class="fa fa-minus-circle"></i></span>
                </td>
              </tr>

              <tr v-if="mode == 'edit'">
                <td class="text-center" colspan="3">
                  <button type="button" class="btn btn-primary" @click="addJobGrade"><i class="fa fa-plus"></i> Add Job
                    Grade</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <table style="width: auto !important" class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 100px">&nbsp;</th>
                <th class="text-center" style="width: 200px">Shift 12-Hours</th>
                <th class="text-center" style="width: 200px">Shift 8-Hours</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Day Shift</td>
                <td v-if="mode == 'view'" class="text-center">{{ shift.shift12Day }}</td>
                <td v-if="mode == 'edit'" class="text-center">
                  <input type="text" v-model="shift.shift12Day" class="form-control height26 text-center" />
                </td>

                <td v-if="mode == 'view'" class="text-center">{{ shift.shift8Day }}</td>
                <td v-if="mode == 'edit'" class="text-center">
                  <input type="text" v-model="shift.shift8Day" class="form-control height26 text-center" />
                </td>
              </tr>

              <tr>
                <td>Night Shift</td>
                <td v-if="mode == 'view'" class="text-center">{{ shift.shift12Night }}</td>
                <td v-if="mode == 'edit'" class="text-center">
                  <input type="text" v-model="shift.shift12Night" class="form-control height26 text-center" />
                </td>

                <td v-if="mode == 'view'" class="text-center">{{ shift.shift8Night }}</td>
                <td v-if="mode == 'edit'" class="text-center">
                  <input type="text" v-model="shift.shift8Night" class="form-control height26 text-center" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-12 mt-4" style="background: #FFF; width: 520px;padding: 15px;">
          <ul style="padding-left: 15px;margin-bottom: 0;">
            <li>12-hour Day - Shift Start Time is between 6am to 6pm</li>
            <li>12-hour Night - Shift Start Time is between 6pm to 6am</li>
            <li>8-hour Day - Shift Start Time is between 12pm to 8pm</li>
            <li>8-hour Night - Shift Start Time is between 9pm to 5am</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- /Job Grade Setting -->

    <!-- Shift Code Setting -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <table style="width: auto !important" class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 250px">Shift</th>
                <th class="text-center" style="width: 200px">Day<br />Allowance</th>
                <th class="text-center" style="width: 200px">Night<br />Allowance</th>
                <th class="text-center" style="width: 200px">Saturday<br />Allowance</th>
                <th class="text-center" style="width: 200px">Sunday<br />Allowance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(code, i) in shiftCodes" :key="code.Id">
                <td class="text-center">
                  <!-- <input type="text" v-model="code.ShiftCode" class="form-control height26 text-center" maxlength="30"
                    required /> -->
                  <select class="form-control height28 text-center" v-model="code.ShiftCodeId" required>
                    <option v-for="item in codes" :key="item.Id" :value="item.Id">
                      {{ item.Code }}
                    </option>
                  </select>
                </td>
                <td>
                  <input type="number" v-model="code.DayAllowance" class="form-control height26 text-center" />
                </td>
                <td>
                  <input type="number" v-model="code.NightAllowance" class="form-control height26 text-center" />
                </td>
                <td>
                  <input type="number" v-model="code.SaturdayAllowance" class="form-control height26 text-center" />
                </td>
                <td style="position: relative">
                  <input type="number" v-model="code.SundayAllowance" class="form-control height26 text-center" />
                  <span @click="removeShiftCode(i)" style="
                                        position: absolute;
                                        right: -8px;
                                        top: 6px;
                                        color: #ff0000;
                                        cursor: pointer;">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                </td>
              </tr>

              <tr v-for="(newCode, i) in newShiftCodes" :key="i">
                <td class="text-center">
                  <select class="form-control height28 text-center" v-model="newCode.ShiftCodeId" required>
                    <option v-for="item in codes" :key="item.Id" :value="item.Id">
                      {{ item.Code }}
                    </option>
                  </select>
                </td>
                <td>
                  <input type="number" v-model="newCode.DayAllowance" class="form-control height26 text-center" />
                </td>
                <td>
                  <input type="number" v-model="newCode.NightAllowance" class="form-control height26 text-center" />
                </td>
                <td>
                  <input type="number" v-model="newCode.SaturdayAllowance" class="form-control height26 text-center" />
                </td>
                <td style="position: relative">
                  <input type="number" v-model="newCode.SundayAllowance" class="form-control height26 text-center" />
                  <span @click="removeNewShiftCode(i)" style="
                                        position: absolute;
                                        right: -8px;
                                        top: 6px;
                                        color: #ff0000;
                                        cursor: pointer;">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                </td>
              </tr>

              <tr>
                <td class="text-center" colspan="5">
                  <button type="button" class="btn btn-primary" @click="addShiftCode">
                    <i class="fa fa-plus"></i> Add Shift Code
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Shift Code Setting -->

    <!-- Save Button -->
    <div class="row mt-4">
      <div class="col-md-12">
        <button @click="save" type="button" class="btn btn-primary"><i class="fa fa-save"></i> Save</button>
      </div>
    </div>
    <!-- /Save Button -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  components: {
  },

  data() {
    return {
      company: "Lam Research Singapore Pte Ltd",
      companies: [],
      jobGrade: [],
      newJobGrade: [],
      shift: [],
      mode: "edit",
      //shift code
      codes: [],
      shiftCodes: [],
      newShiftCodes: [],
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            this.company = this.companies[0].CompanyName;
            this.getOvertimePaymentCalculation();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getOvertimePaymentCalculation() {
      let param = {
        Token: this.token,
        Company: this.company
      };
      this.$store.state.isLoading = true;

      this.shift.shift12Day = 0;
      this.shift.shift12Night = 0;
      this.shift.shift8Day = 0;
      this.shift.shift8Night = 0;

      API.getOvertimePaymentCalculation(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.jobGrade = response.data.record;
            let shift = response.data.shiftOvertimePaymentCalculation;
            if (shift != null) {
              this.shift.shift12Day = shift.Shift12HourDayRate;
              this.shift.shift12Night = shift.Shift12HourNightRate;
              this.shift.shift8Day = shift.Shift8HourDayRate;
              this.shift.shift8Night = shift.Shift8HourNightRate;
            }
            else {
              this.shift.shift12Day = 0;
              this.shift.shift12Night = 0;
              this.shift.shift8Day = 0;
              this.shift.shift8Night = 0;
            }
            this.codes = response.data.shiftCodes;
            this.shiftCodes = response.data.shiftCodeSettings;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    addJobGrade() {
      this.newJobGrade.push({ JobGrade: '', StandBy12HourRate: '', StandBy24HourRate: '' });
    },
    removeNewJobGrade(index) {
      this.newJobGrade.splice(index, 1);
    },
    removeJobGrade(index) {
      this.jobGrade.splice(index, 1);
    },
    changeCompany() {
      this.getOvertimePaymentCalculation();
    },
    //shift code
    addShiftCode() {
      this.newShiftCodes.push({
        Id: "",
        ShiftCodeId: "",
        DayAllowance: "",
        NightAllowance: "",
        SaturdayAllowance: "",
        SundayAllowance: ""
      });
    },
    removeNewShiftCode(index) {
      this.newShiftCodes.splice(index, 1);
    },
    removeShiftCode(index) {
      this.shiftCodes.splice(index, 1);
    },
    save() {
      // check duplicated job grade
      let messages = new Array();
      if (this.newJobGrade.length > 0) {
        for (let index = 0; index < this.newJobGrade.length; index++) {
          let newJG = this.newJobGrade[index].JobGrade;
          for (let loop = 0; loop < this.jobGrade.length; loop++) {
            if (newJG == this.jobGrade[loop].JobGrade) {
              messages.push("New Job Grade '" + newJG + "' is duplicated.");
            }
          }
        }
      }
      // check duplicated shift code
      let allShiftCodes = this.shiftCodes.concat(this.newShiftCodes);
      if (allShiftCodes.length > 0) {
        for (let index = 0; index < allShiftCodes.length; index++) {
          let newSC = allShiftCodes[index].ShiftCodeId;
          for (let loop = 0; loop < allShiftCodes.length; loop++) {
            if (index != loop && newSC == allShiftCodes[loop].ShiftCodeId) {
              let code = this.codes.find(x => x.Id == newSC).Code;
              messages.push("Shift Code '" + code + "' is duplicated.");
            }
          }
        }
      }
      if (messages.length > 0) {
        this.$swal(messages.join("\n"), { icon: "error" });
      }
      else {
        this.$swal({
          title: "Are you sure?",
          text: "Are you sure you want to save the record(s)?",
          icon: "info",
          buttons: true,
          dangerMode: false,
        }).then((willSave) => {
          if (willSave) {
            let param = {
              Token: this.token,
              Company: this.company,
              JobGrade: this.jobGrade,
              NewJobGrade: this.newJobGrade,
              Shift12HourDayRate: this.shift.shift12Day,
              Shift12HourNightRate: this.shift.shift12Night,
              Shift8HourDayRate: this.shift.shift8Day,
              Shift8HourNightRate: this.shift.shift8Night,
              ShiftCodes: this.shiftCodes,
              NewShiftCodes: this.newShiftCodes
            };

            this.$store.state.isLoading = true;

            API.saveOvertimePaymentCalculation(param)
              .then((response) => {
                this.$store.state.isLoading = false;
                if (response.data.success) {
                  this.$swal("Record(s) saved successfully!", {
                    icon: "success",
                  });

                  this.getOvertimePaymentCalculation();
                  this.newJobGrade = [];
                  this.newShiftCodes = [];
                } else {
                  this.$swal(response.data.message, { icon: "error" });
                }
              })
              .catch((error) => {
                this.$store.state.isLoading = false;
                this.$swal(error.response.data.Message, { icon: "error" });
              });
          }
        });
      }
    },
  },

  created() {
    if (this.role != "admin")
      this.$router.replace({ name: "home" });

    this.getCompanies();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/System/OvertimePaymentCalculation.vue